<template>
    <Downloads></Downloads>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const Downloads = defineAsyncComponent(() =>
    import("../../../components/ITDepartment/RemoteWorking/Downloads.vue")
);

export default {
    name: "Remote_Downloads",
    components: { Downloads, AuthLayout },
};
</script>
